import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rIstatistikSonuc_3 } from '../../../../api/models/.catalog';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rIstatistikSonuc_3>,
  rIstatistikSonuc_3
>(ActionSubTypes.API_DEGERLEMETOPLAMDEGER, DefaultInputDataStateModel<pList, rIstatistikSonuc_3>());
